import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType, T4InvoiceInfo, T4CCService } from 't4core';
import * as uuid from 'uuid';

@Component({
  selector: 'ContextDialog',
  templateUrl: 'ContextDialog.html',
  styleUrls: ['./ContextDialog.css']
})
export class ContextDialog extends DialogBase {

  public contextId: string = "";
  public contextName: string = "";

    constructor(
      public dialogRef: MatDialogRef<ContextDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      super("ContextDialog");
      this.contextId = data.contextId;
      this.contextName = data.contextName;
    }

  public async ngOnInit() {
    }

  public static async open(dialog: MatDialog, contextId: string, contextName: string) {
    var dlg = dialog.open(ContextDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "1200px",
      data: {
        contextId: contextId,
        contextName: contextName
      }
    });
  }
}
